/**
 * Employee Web — `/me/profile/personal` tab route.
 *
 * Mounts <PersonalTab> (ProfilePhoto + SelfEdit + Family + Residency)
 * inside the 6-tab profile shell. Emergency contacts live SOLELY on the
 * Emergency tab (`/me/profile/emergency`).
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PersonalTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/personal")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.personal" } },
  component: PersonalTabRoute,
});

function PersonalTabRoute(): JSX.Element {
  return <PersonalTab />;
}
